<!--Barre de navigation-->
<app-nav></app-nav>

<!--Message-->
<p-toast />

<!--Popup de chargement-->
<app-loading></app-loading>
<router-outlet />
